import { MonitorPlay } from 'lucide-react';
import { Link } from 'react-router-dom';

import { coQuyen, useChuaCoKenh, useToi } from '../lib/auth.js';

export interface KhoiChuaCoKenhProps {
  /** Tên trang, để câu đầu nói đúng cái người dùng đang nhìn. */
  tenTrang: string;
}

/**
 * Khối hướng dẫn cho **thành viên chưa được giao kênh nào** (quy tắc 2 của đợt
 * 17/10/2026).
 *
 * Không hiện gì khi người xem thấy cả công ty, hay khi họ đã có ít nhất một
 * kênh — lúc đó trang rỗng là chuyện khác và cần lời khác.
 *
 * Khối này **không** thay thế trạng thái rỗng của từng bảng: nó đứng trên
 * cùng, giải thích vì sao mọi thứ bên dưới đều trống. Thay hẳn nội dung trang
 * sẽ giấu mất những thẻ số 0 vốn đúng, và làm người dùng tưởng trang hỏng.
 */
export function KhoiChuaCoKenh({ tenTrang }: KhoiChuaCoKenhProps) {
  const toi = useToi();
  const chuaCoKenh = useChuaCoKenh();

  if (!chuaCoKenh) return null;

  const themDuocKenh = coQuyen(toi.data?.permissions, 'channels', 'edit');
  const ketNoiDuoc = coQuyen(toi.data?.permissions, 'sync', 'edit');

  return (
    <section
      role="status"
      className="rounded-the border border-vien bg-info-nen px-5 py-4 text-info-chu"
    >
      <div className="flex flex-wrap items-start gap-3">
        <MonitorPlay size={18} aria-hidden="true" className="mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="text-co-ban font-bold">Bạn chưa được giao kênh nào</p>
          <p className="mt-1 text-co-ban">
            {tenTrang} chỉ hiện số liệu của kênh bạn phụ trách, nên đang trống. Đây không phải lỗi.
          </p>
          <ul className="mt-2 list-disc pl-5 text-co-ban">
            {themDuocKenh && (
              <li>
                Tự thêm kênh của mình ở <strong>Quản lý kênh → Thêm kênh</strong>. Kênh bạn tạo được
                giao cho bạn ngay.
              </li>
            )}
            {ketNoiDuoc && (
              <li>
                Đã có kênh trong app thì nối với YouTube ở <strong>Cài đặt → Kết nối API</strong>.
              </li>
            )}
            <li>
              Kênh do người khác thêm từ trước: nhờ quản trị giao cho bạn ở{' '}
              <strong>Nhân sự &amp; phân quyền</strong>.
            </li>
          </ul>

          {(themDuocKenh || ketNoiDuoc) && (
            <p className="mt-3 flex flex-wrap gap-4">
              {themDuocKenh && (
                <Link to="/kenh/moi" className="vung-bam font-semibold underline">
                  Thêm kênh
                </Link>
              )}
              {ketNoiDuoc && (
                <Link to="/cai-dat?tab=ket-noi-api" className="vung-bam font-semibold underline">
                  Kết nối YouTube
                </Link>
              )}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
